import React, { useState } from "react";
import { Box, Grid, Typography, TextField, Button, Checkbox, FormControlLabel } from "@mui/material";
import { useForm } from "react-hook-form";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { callAPI, clearRequest, IRoleMain, LoacalVariables, Method, setLocalValues } from "../../commonFunctions/CommonFunctions";
import backImg from "../../images/Rectangle.png";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSButton from "../../Components/Button/WSButton";
import backgroundImage1 from '../../images/bg2.svg';
import logo from '../../images/melplogo1.svg';
import doctorImage from '../../images/melp-doctor-login-logo.svg'

// import logo from "../../images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
// import doctorImage from '../../images/customer-bg.svg'
import { AllPermissions } from "../../commonFunctions/PermissionManger";
interface LoginFormProps {
  onLogin: (token: string) => void;
}

export const DoctorLoginForm: React.FC<LoginFormProps> = React.memo(({ onLogin }) => {
  const { control, register, handleSubmit, getValues, formState: { errors } } = useForm();
  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleData = async (data: any) => {
    try {
      const request = {
        userName: data.userName,
        password: data.password,
        loginType: 'user'
      }
      const newRequest = clearRequest(request);
      setLoading(true);
      const response: any = await callAPI("Auth/login", Method.POST, newRequest);
      console.log("Login response:", response);

            if (response && response?.data?.accessToken) {
                onLogin( response?.data?.accessToken);
                setLocalValues(LoacalVariables.UserId, response?.data?.id);

                //  const name = `${response?.firstName} ${response?.lastName ? response?.lastName : ''} `
                setLocalValues(LoacalVariables.Name, response?.data?.name);
                // Role permissions: never carry over a previous user's; store them only when the
                // API sends them (shape: [{ page, actions: [{ operation, permission }] }]).
                localStorage.removeItem(IRoleMain.Permissions);
                if (Array.isArray(response?.data?.permissions)) {
                    setLocalValues(IRoleMain.Permissions, response.data.permissions);
                }
                AllPermissions.getInstance();
                showMessage("Logged in successfully!", "success");
            } else {
                throw new Error("Login failed. Please try again.");
            }
        } catch (e: any) {
            showMessage(e.message || "An unexpected error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

  const handleForgotPassword = () => {
    const phoneNumber = getValues('userName');
    navigate('/verifyOtp', { state: { phoneNumber } });
  };

    return (
        <Grid item container>
      {/* <Grid sm={6} style={{ marginTop: -23 }}>
                <img src={logo} style={{ marginTop: -2 }} ></img>
            </Grid> */}
      {/* <Grid sm={6} style={{ marginTop: -23 }} sx={{ mt: -2, display: 'flex', justifyContent: 'flex-end' }}>
                <Typography variant="body2" >Don't have an MHB account ? <Link style={{ textDecoration: 'none' }} to={'/registration'}  >Sign Up</Link></Typography>
            </Grid> */}
      <Grid
        container
        sx={{
          position: 'relative',
          backgroundImage: `url(${backImg})`,
          backgroundSize: 'cover',
          backgroundColor: '#022219',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 2,
        }}
      >  <Box
          component="img"
          src={logo}
          alt="MELP Logo"
          sx={{
            position: 'absolute',
            top: 24,
            left: 54,
            width: 100,
            zIndex: 10,
          }}
        />
        <Grid container sx={{
          position: 'relative',
          minHeight: '80vh',
          backgroundImage: `url(${backgroundImage1})`,
          border: '1px solid #022219',
          borderRadius: 5,
          backgroundSize: 'cover',
          backgroundColor: '#022219',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          width: '80%',
          padding: 7,
        }}>

          <form onSubmit={handleSubmit(handleData)}>
            <Box
              sx={{
                backgroundColor: "white",
                padding: "30px",
                borderRadius: "12px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                maxWidth: "400px",
                width: "100%",
                textAlign: 'center'
              }}
            >
              <img src={doctorImage} height={150}></img>
              <Typography variant="h5" fontWeight="bold" style={{ color: "#098963" }}>
                Welcome Back  <span style={{ color: "#098963" }}></span>
              </Typography>
              <Typography variant="body2" color="#098963" sx={{ mb: 2 }}>
                ️Let’s Get Started
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <WSTextField
                    label="User Name"
                    {...register("userName", { required: "User Name is required" })}
                    id="userName"
                    name="userName"
                    control={control}
                    //  maxLength={10}
                    textIcon="Person"
                    sx={{

                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    label="Password"
                    {...register("password", { required: "Password is required" })}
                    id="password"
                    name="password"
                    control={control}
                    textIcon="Password"
                    type={TextType.Password}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />

                </Grid>


                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      backgroundColor: "#098963",
                      color: "white",
                      padding: "10px",
                      borderRadius: "8px",
                      mt: 0,
                      '&:hover': {
                        backgroundColor: "#379e80", // Change to any color you like
                      },
                    }}
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </Button>

                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary" textAlign="center">
                    Don’t have an account?{' '}
                    <Link to="/register" style={{ textDecoration: 'none', color: '#098963', fontWeight: 500 }}>
                      Register.
                    </Link>
                    <Typography
                      onClick={handleForgotPassword}
                      sx={{ textDecoration: 'none',fontSize: '0.875rem', color: 'red', fontWeight: 500, paddingLeft: 2, cursor: 'pointer' }}
                    >
                      Forgot Password?
                    </Typography>
                  </Typography>
                </Grid>

              </Grid>
            </Box>
          </form>
        </Grid>
      </Grid>
    </Grid >
  );
});
